import Swal from "sweetalert2";
import { useEffect } from "react";
const DeleteModel = ({
  deleteModalOpen,
  setDeleteModalOpen,
  onConfirm,
  itemName,
  isDeleting = false,
}) => {
useEffect(() => {
  if (deleteModalOpen && !isDeleting) {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this ${itemName}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      setDeleteModalOpen(false);

      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleting...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });

        onConfirm()
          .then((res) => {
            if (res?.isSuccess) {
              Swal.fire({
                title: "Deleted!",
                text: `${itemName} has been deleted.`,
                icon: "success",
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: res?.message || `Failed to delete ${itemName}.`,
                icon: "error",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: `Failed to delete ${itemName}.`,
              icon: "error",
            });
          });
      }
    });
  }
}, [
  deleteModalOpen,
  isDeleting,
  itemName,
  onConfirm,
  setDeleteModalOpen
]);
  return null;
};

export const confirmBulkDelete = async ({
  itemType = "items",
  selectedIds = [],
  deleteApiCall = async () => { },
  refreshCallback = async () => { },
  successMessage = "Deleted successfully!",
  failureMessage = "Failed to delete items.",
  partialMessage = "Some items could not be deleted.",
}) => {
  if (selectedIds.length === 0) return;

  const result = await Swal.fire({
    title: "Are you sure?",
    text: `Selected ${itemType} will be deleted. This action cannot be undone.`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete them!",
  });

  if (result.isConfirmed) {
    Swal.fire({
      title: "Deleting...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const res = await deleteApiCall(selectedIds);
      const undeleted = res?.notDeleted || [];
      if (undeleted.length > 0) {
        await Swal.fire({
          title: "Partial Delete",
          icon: "info",
          html: `
       <p>${partialMessage}</p>
       <p><strong>IDs not deleted:</strong> ${undeleted.join(", ")}</p>
     `,
        });
      } else {
        await Swal.fire("Deleted!", successMessage, "success");
      }

      await refreshCallback();
      return { success: true, undeleted };
    } catch (err) {
      await Swal.fire("Error!", failureMessage, "error");
      return { success: false };
    }
  }
};
export default DeleteModel;
